import React, { useState } from 'react';
import { isMobile } from 'react-device-detect';
import { Box, Typography, Container } from '@mui/material';
import swiseLogo from '../assets/swise_white.png';
import LanguageSelector from './LanguageSelector';
import { useTranslation } from 'react-i18next';

interface Props {
  children: React.ReactNode;
}

const DeviceGuard: React.FC<Props> = ({ children }) => {
  const { t, i18n } = useTranslation();
  const [language, setLanguage] = useState(i18n.language.toUpperCase().slice(0, 2)); // 'EN', 'ES', etc.

  const handleLanguageChange = (code: string) => {
    setLanguage(code);
    i18n.changeLanguage(code.toLowerCase());
  };

  if (isMobile) {
    return (
      <Box
        sx={{
          backgroundColor: 'black',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          px: 2,
          position: 'relative',
        }}
      >
        <LanguageSelector selected={language} onChange={handleLanguageChange} />

        <Box
          sx={{
            width: '100%',
            textAlign: 'center',
            mt: 4,
          }}
        >
          <Box
            component="img"
            src={swiseLogo}
            alt="Swise Logo"
            sx={{
              maxWidth: 100,
              height: 'auto',
              display: 'inline-block',
            }}
          />
        </Box>
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
          }}
        >
          <Container maxWidth="sm" sx={{ textAlign: 'center' }}>
            <Typography variant="h3" gutterBottom color="white">
              VDR
            </Typography>
            <Typography
              variant="h6"
              sx={{ color: '#73AF73', fontWeight: 500, mt: 2 }}
            >
              {t('notAvailable')}
            </Typography>
            <Typography variant="body1" sx={{ color: '#ccc', mt: 1 }}>
              {t('accessFromDesktop')}
            </Typography>
          </Container>
        </Box>
      </Box>
    );
  }

  return <>{children}</>;
};

export default DeviceGuard;